import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PublicBlogPost } from '../../project-data';

@Component({
  selector: 'app-blog-detail-page',
  templateUrl: './blog-detail-page.component.html',
})
export class BlogDetailPageComponent {
  @Input({ required: true }) post!: PublicBlogPost;
  @Input() loading = false;
  @Input() error = false;
  @Output() readonly backRequested = new EventEmitter<void>();

  protected postMeta(post: PublicBlogPost): string {
    const date = this.postDateLabel(post);
    return post.category ? `${date} / ${post.category}` : date;
  }

  protected postDateLabel(post: PublicBlogPost): string {
    if (!post.published_at) {
      return 'Unscheduled';
    }

    return new Intl.DateTimeFormat('en', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(post.published_at));
  }
}
